export enum HeadingVariant {
  PAGE_TITLE = 'page-title',
  SECTION = 'section',
}

export enum HtmlTag {
  DIV = 'div',
  P = 'p',
  SPAN = 'span',
}

export enum MarginBottom {
  MD = 'md',
  NONE = 'none',
  SM = 'sm',
}

export enum TextColor {
  MUTED = 'muted',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum TextVariant {
  BODY = 'body',
  BODY_SMALL = 'body-small',
  CAPTION = 'caption',
}
